var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ1BackToMenuArrowB(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 39a13 13 0 01-13 13H13v-4h42a9 9 0 000-18H20v10L8 28l12-12v10h35a13 13 0 0113 13z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J1_Back_to_menu_arrow_B.e5de25ec.svg";
export { SvgJ1BackToMenuArrowB as ReactComponent };